import React from 'react';

const Flag = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='16'
      viewBox='0 0 12 16'
      fill='none'
      {...props}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M0.580645 0C0.901324 0 1.16129 0.24989 1.16129 0.55814V1.36569L2.37955 1.13148C3.76783 0.864588 5.20692 0.991591 6.52142 1.49701L6.67904 1.55763C7.77437 1.97878 8.97987 2.05742 10.1244 1.78239C11.0771 1.55344 12 2.2461 12 3.19009V8.67252C12 9.40815 11.4792 10.0493 10.7367 10.2277L10.5708 10.2676C9.08237 10.6253 7.51455 10.523 6.09012 9.97529C4.98472 9.55029 3.77467 9.4435 2.6073 9.66794L1.16129 9.94597V15.4419C1.16129 15.7501 0.901324 16 0.580645 16C0.259966 16 0 15.7501 0 15.4419V0.55814C0 0.24989 0.259966 0 0.580645 0ZM1.16129 8.80752L2.37955 8.57332C3.76783 8.30646 5.20692 8.43349 6.52142 8.93886C7.71917 9.39944 9.03755 9.4854 10.2891 9.18467L10.4551 9.14478C10.6805 9.0906 10.8387 8.89593 10.8387 8.67252V3.19009C10.8387 2.97232 10.6258 2.81252 10.406 2.86535C9.0247 3.19728 7.56975 3.10236 6.24774 2.59407L6.09012 2.53345C4.98472 2.10845 3.77467 2.00166 2.6073 2.22608L1.16129 2.50407V8.80752Z'
        fill='#21231E'
      />
    </svg>
  );
};

export default Flag;
